import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="py-12 sm:py-24 px-4 bg-surface relative" data-id="element-112">
      <div className="max-w-3xl mx-auto text-center" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-114">
          <div className="w-12 h-px bg-accent mx-auto mb-8" data-id="element-115"></div>

          <p className="font-serif text-2xl sm:text-3xl leading-relaxed text-text mb-8" data-id="element-116">
            ¿Alguna vez has entrado a una tienda de diseño minimalista y te has
            enamorado de una pieza de arte geométrica,{' '}
            <span className="text-accent italic" data-id="element-117">
              solo para ver que cuesta cientos de dólares?
            </span>
          </p>

          <p className="text-lg text-textMuted leading-relaxed mb-8" data-id="element-118">
            ¿O quizás has intentado hacer una manualidad de Pinterest que
            terminó pareciendo un proyecto escolar aplastado?
          </p>

          <p className="text-xl font-medium text-text" data-id="element-119">
            No es tu falta de talento... <br className="hidden sm:block" data-id="element-120" />
            <span className="text-accent" data-id="element-121">
              es que te han dado las herramientas equivocadas.
            </span>
          </p>

          <div className="w-12 h-px bg-accent mx-auto mt-8" data-id="element-122"></div>
        </motion.div>
      </div>
    </section>;
}